import React from "react";
import { TempleJourneyStats } from "@/types/temple.types";
import { Trophy } from "lucide-react";

interface TempleProgressCardProps {
  stats: TempleJourneyStats;
}

export function TempleProgressCard({ stats }: TempleProgressCardProps) {
  return (
    <div className="bg-white rounded-xl border border-black/[0.06] shadow-[0_1px_3px_rgba(0,0,0,0.03)] overflow-hidden">
      <div className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-[9px] bg-accent-800/[0.06] flex items-center justify-center">
              <Trophy className="w-4 h-4 text-accent-800" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-neutral-800">
                {stats.completedTemples} de {stats.totalTemples} Templos
              </h3>
              <p className="text-xs text-neutral-400">
                {stats.overallProgress}% completo
              </p>
            </div>
          </div>
        </div>

        <div className="h-[5px] bg-black/[0.04] rounded-full overflow-hidden mb-3">
          <div
            className="h-full bg-gradient-to-r from-accent-800 to-accent-600 rounded-full transition-all duration-500"
            style={{ width: `${stats.overallProgress}%` }}
          />
        </div>

        <div className="grid grid-cols-3 gap-2">
          <div className="text-center py-2 rounded-lg bg-emerald-500/[0.06] border border-emerald-500/[0.08]">
            <p className="text-base font-bold text-emerald-600 tabular-nums">
              {stats.completedTemples}
            </p>
            <p className="text-[9px] text-emerald-600/60 font-semibold uppercase tracking-wider">
              Completos
            </p>
          </div>
          <div className="text-center py-2 rounded-lg bg-accent-800/[0.05] border border-accent-800/[0.06]">
            <p className="text-base font-bold text-accent-800 tabular-nums">
              {stats.activeTemples}
            </p>
            <p className="text-[9px] text-accent-800/50 font-semibold uppercase tracking-wider">
              Ativos
            </p>
          </div>
          <div className="text-center py-2 rounded-lg bg-black/[0.02] border border-black/[0.04]">
            <p className="text-base font-bold text-neutral-400 tabular-nums">
              {stats.blockedTemples}
            </p>
            <p className="text-[9px] text-neutral-400/60 font-semibold uppercase tracking-wider">
              Bloqueados
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
